import { forwardRef } from 'react';

import { Footer } from './Footer';
import { FooterSlots } from './FooterSlots';
import type { FooterVariant, RootFooterProps } from './types';

const FooterNamespace = Footer as typeof Footer & {
  Socials: typeof FooterSlots.Socials;
  TopSection: typeof FooterSlots.TopSection;
  LanguagePicker: typeof FooterSlots.LanguagePicker;
} & Record<
    FooterVariant,
    React.ForwardRefExoticComponent<
      Omit<RootFooterProps, 'ref' | 'variant'> &
        React.RefAttributes<HTMLDivElement>
    >
  >;

FooterNamespace.FooterBaseSaas = forwardRef<
  HTMLDivElement,
  Omit<RootFooterProps, 'variant'>
>(({ children, ...props }, ref) => (
  <Footer {...props} variant="FooterBaseSaas" ref={ref}>
    {children}
  </Footer>
));

FooterNamespace.Socials = FooterSlots.Socials;
FooterNamespace.TopSection = FooterSlots.TopSection;
FooterNamespace.LanguagePicker = FooterSlots.LanguagePicker;

export { FooterNamespace as Footer, FooterSlots };
